import { isInFiltersPolishExperiment } from '@client/redux/experiments/selectors/filters-polish';
import { useAppSelector } from '@client/redux/hooks';
import {
	filterConfigsSidebarAtom,
	selectedSidebarFiltersAtom,
} from '@pages/VendorsSearch/containers/FilterPills/components/Sidebar/atoms';
import { TextBody } from '@tkww/orion-web-ds-text';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import React, { type FC } from 'react';
import { labels } from '../../../utils';
import { CATEGORY_FILTER_ID } from '../../atoms';
import { MultiOption } from '../MultiOption';
import { SingleOption } from '../SingleOption';
import { StartingPriceFilterSidebarOption } from '../StartingPriceFilter/starting-price-filter-sidebar-option';
import Styles from './styles.scss';
const CATEGORY_COLLAPSED_COUNT = 10;
const DEFAULT_SIDEBAR_COLLAPSED_COUNT = 8;

const calcHeight = (len: number): number => {
	const isEven = len % 2 === 0;
	const half = Math.floor(len / 2);
	return isEven ? half * 50 : (half + 1) * 50;
};

export interface SidebarOptionsProps {
	isMobile: boolean;
}

const SidebarOptions: FC<SidebarOptionsProps> = ({ isMobile }) => {
	const isFilterPolishEnabled = useAppSelector(isInFiltersPolishExperiment);
	const selectedSidebarFilters = useAtomValue(selectedSidebarFiltersAtom);
	const filterConfigsSidebar = useAtomValue(filterConfigsSidebarAtom);

	return (
		<div className="sidebarFiltersWrapper">
			{filterConfigsSidebar.length > 0 &&
				filterConfigsSidebar.map((filterConfig) => {
					const isSingleSelect = filterConfig.type === 'facet-single-select';
					const filterName =
						labels[filterConfig.name as keyof typeof labels] ||
						filterConfig.name;

					const isCollapsible = filterConfig.id === CATEGORY_FILTER_ID;
					const useRowMajorGrid =
						isFilterPolishEnabled && !isMobile && !isCollapsible;
					const splitOptionsClassName = classNames(Styles.splitOptions, {
						[Styles.splitOptionsGrid]: useRowMajorGrid,
					});
					const splitOptionStyle =
						useRowMajorGrid || isMobile || isCollapsible
							? {}
							: { height: calcHeight(filterConfig.filterOptions.length) };

					if (filterConfig.type === 'pricing') {
						return <StartingPriceFilterSidebarOption key={filterName} />;
					}

					return (
						<div className={Styles.filterWrapper} key={filterName}>
							<TextBody size="md" className={Styles.filterLabel} bold>
								{filterName.charAt(0).toUpperCase() +
									filterName.slice(1).toLowerCase()}
							</TextBody>
							<div className={splitOptionsClassName} style={splitOptionStyle}>
								{isSingleSelect ? (
									<SingleOption
										filter={filterConfig}
										selectedSidebarFilters={selectedSidebarFilters}
										isFilterPolishEnabled={isFilterPolishEnabled}
									/>
								) : (
									<MultiOption
										filter={filterConfig}
										selectedSidebarFilters={selectedSidebarFilters}
										isFilterPolishEnabled={isFilterPolishEnabled}
										collapsedCount={
											isFilterPolishEnabled
												? DEFAULT_SIDEBAR_COLLAPSED_COUNT
												: filterConfig.id === CATEGORY_FILTER_ID
													? CATEGORY_COLLAPSED_COUNT
													: undefined
										}
									/>
								)}
							</div>
						</div>
					);
				})}
		</div>
	);
};

export default SidebarOptions;
